import { forwardRef, useMemo } from "react";
import PropTypes from "prop-types";
import moment from "moment/moment";
import { DEFAULT_LEFT, useDailyCalendarStyles } from "../edReviewCalendarDaily";
import { useSelector } from "react-redux";
import { isModifying } from "../../../../../../store/reducers/reviews";

const CurrentTimeHorizontalLine = forwardRef(
  (
    { date, yAxisFromTop, leftOffset, width, onlyTimeIndicator, onlyLine },
    ref,
  ) => {
    const classes = useDailyCalendarStyles();

    const isManupulationStateModifying = useSelector(isModifying);

    const currentTimeContainerWidth = 50;

    const renderTimeIndicator = useMemo(() => {
      return onlyTimeIndicator || (!onlyLine && !onlyTimeIndicator);
    }, [onlyLine, onlyTimeIndicator]);

    const renderLine = useMemo(() => {
      return onlyLine || (!onlyLine && !onlyTimeIndicator);
    }, [onlyLine, onlyTimeIndicator]);

    return (
      <>
        {renderTimeIndicator && (
          <div
            ref={ref}
            className={classes.currentTimeLineContainer}
            style={{
              top: yAxisFromTop(true),
              zIndex: isManupulationStateModifying ? 100 : 201,
              left: DEFAULT_LEFT - (currentTimeContainerWidth + 2),
              width: `${currentTimeContainerWidth + leftOffset}px)`,
              visibility: !date.isSame(moment(), "date")
                ? "hidden"
                : "",
            }}
          >
            {moment().format("HH:mm")}
          </div>
        )}

        {renderLine && (
          <div
            ref={ref}
            className={classes.currentTimeLine}
            style={{
              left: 0,
              top: yAxisFromTop(),
              width: `calc(${width}px - ${DEFAULT_LEFT}px)`,
              minWidth: `calc(${width}px - ${DEFAULT_LEFT}px)`,
              zIndex: isManupulationStateModifying ? 100 : 201,
              visibility: !date.isSame(moment(), "date")
                ? "hidden"
                : "",
            }}
          />
        )}
      </>
    );
  },
);

CurrentTimeHorizontalLine.propTypes = {
  date: PropTypes.object,
  onlyLine: PropTypes.bool,
  yAxisFromTop: PropTypes.func,
  onlyTimeIndicator: PropTypes.bool,
  leftOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CurrentTimeHorizontalLine.defaultProps = {
  onlyLine: false,
  onlyTimeIndicator: false,
};

export default CurrentTimeHorizontalLine;
